import { render, staticRenderFns } from "./features.vue?vue&type=template&id=862aa79e&scoped=true&lang=pug&"
import script from "./features.vue?vue&type=script&lang=js&"
export * from "./features.vue?vue&type=script&lang=js&"
import style0 from "./features.vue?vue&type=style&index=0&id=862aa79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862aa79e",
  null
  
)

/* custom blocks */
import block0 from "./features.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsChip: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/widgets/chip.vue').default,WidgetsResultsChiplist: require('/home/ubuntu/nuxt/bonkers/releases/20230921151340/components/widgets/results/chiplist.vue').default})
